<template>

    <div class="keyFigure">
        <div class="keyFigure_title" v-html="title"></div>
        <div class="keyFigure_figure_image" v-if="topImage">
            <img :src="imgPath(topImage)">
        </div>
        <div class="keyFigure_figure">
            <div class="keyFigure_figure_prefix" v-if="prefix"v-html="prefix"></div>
            <div class="keyFigure_figure_number" v-if="figure" :class="{'keyFigure_figure_number_noMarge': noMarge}">
                <ICountUp
                    v-if="figure && !noNum"
                    :duration=3
                    :decimals="figureDecimals"
                    :startVal=0
                    :endVal="figure"
                    :options="options"
                />
	            <span v-if="noNum" v-html="figure"></span>
            </div>
            <div class="keyFigure_figure_suffix" v-if="suffix" v-html="suffix"></div>
            <div class="keyFigure_figure_icon" v-if="icon">
                <fa :icon="icon" />
            </div>
        </div>

        <div class="keyFigure_subtitle" v-html="subTitle"></div>
        <div class="keyFigure_content">
            <Collapser :noCollapse="noCollapse">
                <div v-html="content">
                </div>
                <div class="keyFigure_content_source" v-if="source" v-html="source">
                </div>
            </Collapser>
        </div>
    </div>

</template>



<script>
    import Collapser from "./Collapser";
    import ICountUp from "vue-countup-v2";
    import {i18n} from "../plugin/i18n";
    import Spinner from "@/components/Spinner.vue";
    export default {
        name: 'KeyFigure',
        components: {Spinner, Collapser,ICountUp},
        props: {
            title: {
                type: String,
                default: '',
            },
            figure: {
                type: Number,
                default: 0,
            },
            figureDecimals: {
                type: Number,
                default: 0,
            },
            prefix: {
                type: String,
                default: '',
            },
            suffix: {
                type: String,
                default: '',
            },
            separator: {
                type: String,
                default: ',',
            },
            icon: {
                type: String,
                default: '',
            },
            topImage: {
                type: String,
                default: '',
            },
            subTitle: {
                type: String,
                default: '',
            },
            content: {
                type: String,
                default: '',
            },
            source: {
                type: String,
                default: '',
            },
            noCollapse: {
                type: Boolean,
                default: false,
            },
	        noMarge: {
		        type: Boolean,
		        default: false,
	        },
	        noNum: {
		        type: Boolean,
		        default: false,
	        }
        },
        data() {
            return {
                options: {
                    useEasing: true,
                    useGrouping: true,
                    separator: i18n.t('counterUpSeparator'),
                    decimal: i18n.t('counterUpDecimal'),
                    prefix: '',
                    suffix: ''
                }
            };
        },
	    created() {
		    this.validatedEndVal(this.figure);
	    },
        methods: {
            imgPath: function(image){
                return require('../assets/img/'+image);
            },
	        validatedEndVal(value) {
		        console.log(value);
		        if (typeof value !== 'number' || isNaN(value)) {
			        this.noNum = true;
		        }
				console.log(this.noNum);
	        }
        },
    };
</script>

<style scoped lang="scss">
    .keyFigure{

        &_title{
            text-transform: uppercase;
            font-size: 3rem;
            font-weight: $FW-semibold;
            margin-bottom:  $G-default/5;
            font-family: $F-Montserrat;
        }

        &_figure{
            margin-bottom:  $G-default/3;
            font-weight: $FW-semibold;
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;
            text-transform: uppercase;
            font-family: $F-Montserrat;

            &_number {
                font-size: 5rem;
                padding-right: $G-default/2;

                &_noMarge {
                    padding-right: 0;
                }
            }

            &_prefix {
              font-size: 2rem;
              font-family: $F-SourceSansPro;
              font-weight: $FW-normal;
              text-transform: none;
              width: 100%;
              margin-top: $G-default/4;
            }

            &_suffix {
                font-size: 3rem;
            }
            &_image {
                width: 8rem;
            }
        }
        &_content{
            font-size: 2rem;
            &_source {
                font-size: 1.6rem;
                font-style: italic;
            }
        }
    }
</style>